import { Drawer as MaterialDrawer } from '@mui/material';

export default MaterialDrawer;
